import React, { Component } from 'react';
// import './ProductList.css';


class ProductList extends Component {

  constructor() {
        super();
        this.state = {
          currentPage: 1,
          itemsPerPage: 50
        };
        this.handleClick = this.handleClick.bind(this);
      }

      handleClick(event) {
        this.setState({
          currentPage: Number(event.target.id)
        });
      }

      componentDidUpdate(oldProps) {

        const newProps = this.props
        if(oldProps.data !== newProps.data) {
          this.setState({ currentPage : 1  })
        }
      }





      color(input) {

        //console.log(input);
        if (input.includes("Real-Time PCR") ) {
          //console.log("YES");
          return "color-orange";
        };

        return "color-grey";

      }



  render() {
    console.log("render ProductList");
    // const  data  = this.props.data;
    const {  currentPage, itemsPerPage } = this.state;

    const items = this.props.data;

        // Logic for displaying current items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);

        console.log("currentItems.length",currentItems.length);

        // const renderItems = currentItems.map((item, index) => {
        //   return <li key={index}>{item}</li>;
        // });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(items.length / itemsPerPage); i++) {
          pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {

          if (pageNumbers == 1) { return; }

          return (
            <li
              key={number}
              id={number}
              onClick={this.handleClick}
            >
              {number}
            </li>
          );
        });



    return (

      <div className="product-list-container mb-3">

      <div className="product-list p-3 border border-primary roundedx" style={{borderRadius:15}}>


      {currentItems.length > 0 ?

      <ul className="p-1" style={{paddingLeft:0, minHeight: 500, maxHeight: 600, overflow:'auto'}}>
      {currentItems.map( (currentItems,i) =>
        <li key={i} className="list-unstyled">
          <div className="row no-gutters">

          <div className="col-md-2 text-center">
            <a href={currentItems.link}>
            {currentItems.image &&
              //<img src={ 'https://www.generon.it/wp-content/themes/generon-understrap-child/images/generon-logo-small.jpg'}  width="70" alt="" />

              <img src={ 'https://www.generon.it/immagini/150-' + currentItems.image }  width="100" alt="" />


            }

            </a>
          </div>

          <div className="col-md-9 mt-1">
            <a href={currentItems.link} title="test" className={this.color(currentItems.tecnologie_names)} >
            <div dangerouslySetInnerHTML={{__html: currentItems.title.rendered}} />

            </a>
            <div><strong>{currentItems.codice_prodotto}</strong>  - {this.props.formatoLabel}: <strong>{currentItems.acf.formato}</strong></div>


              <div className="d-nonex">
            {this.props.tecnologiaLabel}: <strong>{currentItems.tecnologie_names.map((object) => { return object + ' '; })}</strong>
            - tags: <strong>{currentItems.product_tag_names.map((object) => { return object + ' '; })}</strong>
            </div>



          </div>

           { (this.color(currentItems.tecnologie_names) == "color-orange") &&  
          <div className='col-md-1' >
          
              <img src="https://www.generon.it/wp-content/themes/generon-understrap-child/images/ICON_tecnologia_PCR-small-min.jpg" width="50" />
          
            </div>  
            } 



          </div>
           <hr className="border-primary" />
        </li>
      )}
    </ul>

            :
          <div>{this.props.nessunRisultato}</div>


    }




      </div>

  <div className="small pt-2">Tot: {items.length}</div>


        <ul id="page-numbers">
          {renderPageNumbers}
        </ul>





      </div>

    );



  }

}

export default ProductList;
